export const directAccessConfigs = {
  bcon: {
    directUrls: [
      '/en-US/directAccessToBcon',
      '/fr-CA/directAccessToBcon'
    ],
    webformUrls: {
      'en-US': '/en-US/TELUS_Business_Connect_Quote_Tool_Order_Form/Business_Connect_Quote_Tool',
      'fr-CA': '/fr-CA/TELUS_Business_Connect_Quote_Tool_Order_Form/Business_Connect_Quote_Tool'
    }
  },
  reports: {
    directUrls: [
      '/en-US/reports',
      '/fr-CA/reports',
      '/en-US/analytics',
      '/fr-CA/analytics'
    ],
    webformUrls: {
      'en-US': '/en-US/black-friday-reports',
      'fr-CA': '/fr-CA/black-friday-reports'
    }
  },
  bconPartner: {
      directUrls: [
        '/en-US/directAccessToBconPartners',
        '/fr-CA/directAccessToBconPartners'
      ],
      webformUrls: {
        'en-US': '/en-US/TELUS_Business_Connect_Quote_Tool_Order_Form/Business_Connect_Quote_Tool',
        'fr-CA': '/fr-CA/TELUS_Business_Connect_Quote_Tool_Order_Form/Business_Connect_Quote_Tool'
      },
      usePartnerSSO: true
    }
};

